var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import Q from "q";
import Enums from "./Enums.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const SWAP_PAGE_TIME = 200;
const fn = {};
function zoom($el, start, finish) {
  const deferred = Q.defer();
  $el.animate({
    "text-indent": 1
  }, {
    duration: 200,
    easing: "swing",
    step: function(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css("transform", "scale(" + now + ", " + now + ")");
    },
    always: function() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}
function rotate($el, start, finish) {
  const deferred = Q.defer();
  $el.animate({
    "text-indent": 1
  }, {
    duration: 150,
    easing: "swing",
    step: function(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css("transform", "rotate(" + now + "deg)");
    },
    always: function() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}
fn.swapPages = function(options) {
  const deferred = Q.defer();
  const $parent = options.$parent;
  const $oldRoot = options.$oldRoot;
  const $newRoot = options.$newRoot;
  const success = options.success;
  const ctx = options.ctx;
  let directionClassName = "transition-from-right";
  if (options.dir && options.dir === Enums.DIRECTION_BACK) {
    directionClassName = "transition-from-left";
  }
  $newRoot.addClass(directionClassName);
  $parent.append($newRoot);
  $parent.addClass("animation-container-overflow");
  const newRootAnimations = {
    left: "0px",
    top: "0px",
    opacity: 1
  };
  $newRoot.animate(newRootAnimations, SWAP_PAGE_TIME, function() {
    $parent.removeClass("animation-container-overflow");
    $newRoot.removeClass(directionClassName);
    const clearStyles = Object.keys(newRootAnimations).reduce((styles, attr) => __spreadProps(__spreadValues({}, styles), {
      [attr]: ""
    }), {});
    $newRoot.css(clearStyles);
    success.call(ctx);
    deferred.resolve();
  });
  $oldRoot.animate({
    height: $newRoot.height(),
    opacity: 0
  }, SWAP_PAGE_TIME * 0.8);
  return deferred.promise;
};
fn.swapBeacons = function(options) {
  const $el = options.$el;
  const swap = options.swap;
  const ctx = options.ctx;
  return this.implode($el).then(function() {
    swap.call(ctx);
    return $el;
  }).then(this.explode);
};
fn.explode = function($el) {
  return zoom($el, 0, 1);
};
fn.implode = function($el) {
  return zoom($el, 1, 0);
};
fn.radialProgressBar = function(options) {
  const radialProgressBar = options.$el;
  const swap = options.swap;
  const circles = radialProgressBar.children();
  return rotate(circles, 0, 180).then(function() {
    radialProgressBar.css({
      clip: "auto"
    });
  }).then(function() {
    const leftHalf = circles.eq(0);
    swap();
    return rotate(leftHalf, 180, 360);
  }).then(function() {
    radialProgressBar.css({
      clip: "rect(0px, 96px, 96px, 48px)"
    });
    circles.css({
      transform: "rotate(0deg)",
      "text-indent": "1px"
    });
  });
};
export { fn as default };
